import Api from "@/services/Api";

export default {
  index() {
    return Api().get("campaigns");
  },
  view(campaignId) {
    return Api().get("campaigns/" + campaignId);
  },
  store(form) {
    return Api().post("campaigns", form);
  },
  destroy(campaignId) {
    return Api().delete("campaigns/" + campaignId);
  },
  attachUser(campaignId, userId) {
    return Api().put("campaigns/" + campaignId + "/attach_user", {user_id: userId});
  },
  detachUser(campaignId, userId) {
    return Api().put("campaigns/" + campaignId + "/detach_user", {user_id: userId});
  },
  indexDetachedUsers(campaignId) {
    return Api().get("campaigns/" + campaignId + "/detached");
  },
  indexAttachedUsers(campaignId) {
    return Api().get("campaigns/" + campaignId + "/attached");
  },
  raiseProsperity(campaignId) {
    return Api().get("campaigns/" + campaignId + "/raise_prosperity");
  },
  lowerProsperity(campaignId) {
    return Api().get("campaigns/" + campaignId + "/lower_prosperity");
  },
  attachScenario(campaignId, scenarioId) {
    return Api().put("campaigns/" + campaignId + "/attach_scenario", {
      scenario_id: scenarioId
    });
  },
  detachScenario(campaignId, scenarioId) {
    return Api().put("campaigns/" + campaignId + "/detach_scenario", {
      scenario_id: scenarioId
    });
  },
  attachCharacterClass(campaignId, characterClassId) {
    return Api().put("campaigns/" + campaignId + "/attach_character_class", {
      character_class_id: characterClassId
    });
  },
  unlockItemsByProsperity(campaignId) {
    return Api().put("campaigns/" + campaignId + "/unlock_items_by_prosperity");
  },
  unlockItemsByNumber(campaignId, itemId) {
    return Api().put("campaigns/" + campaignId + "/unlock_items_by_number/" + itemId);
  },
  updateNotes(campaignId, form) {
    return Api().put("campaigns/" + campaignId + "/update_notes", form);
  }
};